export default "__VITE_ASSET__73954fec__"